import { useInfiniteTableQuery } from '@/hooks/useInfiniteTableQuery';
import { monitorDetailInfiniteQueryOptions } from '../api/question.api';
import type { MonitorSearch } from '../types/question.types';

export type InstituteHolderLookup = Pick<MonitorSearch, 'projectId' | 'userId' | 'instituteId'>;

export function useInstituteHolder(projectInstituteId: number, lookup: InstituteHolderLookup) {
  const holderQuery = useInfiniteTableQuery(
    monitorDetailInfiniteQueryOptions(
      { projectId: lookup.projectId, userId: lookup.userId, instituteId: lookup.instituteId },
      true,
    ),
  );
  const holder = holderQuery.rows.find((row) => row.projectInstituteId === projectInstituteId);

  return { holder, isLoading: holderQuery.isLoading };
}
